// https://www.youtube.com/watch?v=WbV3zRgpw_E&t=6960s
import React, { useState }  from 'react'
import Title from '../_title/Title'
import Home2 from './Home2'
import Home3 from './Home3'
import Home4 from './Home4'
import Home5 from './Home5'
import Home6 from './Home6'


const HomeScreen = () => {
  const [isSecondComponentVisible, setIsSecondComponentVisible] = useState(false)
  const galleryTitle = isSecondComponentVisible ? "Hide gallery" :  "Gallery" 
  const handleButtonClick = () => { 
    setIsSecondComponentVisible(!isSecondComponentVisible); 
  };
  return (
    <div>
      <Title subTitle="" title="  "/>
      <Home2/>
      <Home3/>
      <Home4/>
      <Home6/>
      <Home5/>
    </div>

  )
}

export default HomeScreen